<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-panel-pie-chart" :id="chartId">
    <div v-if="pieChartData.displayValue!='N/A'" class="display-value">
      
    </div>
    <div v-else class="display-value twoNumbers"  :class="{'no-color': markColor(piePercentageValue)=='no-color'}">
      N/A
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import WyUtils from '../../../library/wy-utils';

export default Vue.extend({
  name: 'wy-panel-pie-chart',
  props: ['chartId', 'pieChartData'],

  data() {
    return {
      module: this,
      loading: false,
      chart: null,
      maxLegendNumber: 4
    }
  },
  computed: {    
    ...mapGetters(['dataModel', 'companyConfig'])
  },
  methods: {

    toggleLegend(legendsData) {
      // let mapLagends = WyPanelUtils.mapLagends;
      this.localData = JSON.parse(JSON.stringify(this.pieChartData));
      legendsData.forEach((legendData, index) => {
        if(!legendData.toggle) {
          this.localData.percent[index] = null;
          this.localData.values[index] = null
        }
      })
      this.buildChart('legend');
    },
    buildChart(mode) {
      setTimeout(()=>{
        if(!mode) {
          this.localData = JSON.parse(JSON.stringify(this.pieChartData));
        }
        var data = [{
          values: this.localData.values, //[15, 20, 75],]
          // volumes: this.pieChartData.values,
          labels: this.localData.legends, //['English', 'French', 'Spanish'],
          percents: this.localData.percents,
          name: '',
          hole: .65,
          textinfo: "percent",
          texttemplate: "%{percent:.1%}",
          textposition: (this.localData.legends.length > this.maxLegendNumber) ? "none" : "outside",
          // textposition: "none",
          type: 'pie',
          hovertemplate: " %{label} <br /> %{value} (%{percent:.2%}) ",
          'marker': {
            'colors': this.localData.legendColors,
            line: {
              color: 'white', 
              width: 0.5
              }
          },
          hoverinfo: 'none',
          }];

        var layout = {
          automargin: true,
          hovermode: 'x',
          margin: { l: 20, r: 20, t: 50, b: 50, pad: 0},
          annotations: [
          {   
              text: WyUtils.bigNumberFormatter(this.localData.displayValue),
              font: {
                size: 18.65,
                family: 'Helvetica Neue, Helvetica, arial, sans-serif'
              },
              showarrow: false,
              x: 0.5,
              y: 0.5
          }
          ],
          showlegend: false,
          legend: {
              orientation: 'h',
              x: -0.24,
              y: 0,
          },
          
          hoverlabel: {
            bgcolor: 'white',
            font: {
              size: 14,
              family: 'Helvetica Neue, Helvetica, arial, sans-serif',
              color: 'black'
            },
            align: 'left',
            namelength: 50,
            bordercolor: '#eee',
          },
          height: 280,
          // width: 480,
          // autorange: true,
          // grid: {rows: 1, columns: 2}
        };
        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        let total = 0;
        data[0].values.forEach(value=>{
          total = total + value
        })
        if(total == 0) {
          data[0].values.push(100)
          data[0].labels.push('no data')
          data[0].marker.colors[data[0].labels.length-1] = "#CCC";
          data[0].textposition = 'none';
          layout.hovermode = false;
        }
        // eslint-disable-next-line no-undef
        Plotly.newPlot(this.chartId, data, layout, config);
      }, 50)
    }
  },

  created() {
    if(this.companyConfig && this.companyConfig.chartSetting && this.companyConfig.chartSetting.pieChart && (this.companyConfig.chartSetting.pieChart.maxLegendNumber || this.companyConfig.chartSetting.pieChart.maxLegendNumber == 0)) {
      if(typeof(this.companyConfig.chartSetting.pieChart.maxLegendNumber) == 'number' && this.companyConfig.chartSetting.pieChart.maxLegendNumber >= 0) {
        this.maxLegendNumber = this.companyConfig.chartSetting.pieChart.maxLegendNumber;
      }
    }
  },

  mounted(){
    
    this.buildChart()
  }
});
</script>

<style lang="scss">
  .wy-panel-pie-chart {
    position: relative;
    height: 250px;
    cursor: pointer;
    .hoverlayer{
      .nums .line:first-child{
        font-weight: 400 !important;
        fill: #4B5158 !important;
        font-size: 14.22px !important;
      }
      .nums .line:last-child{
        font-weight: 500 !important;
        font-size: 14.22px !important;
        fill: var(--site-font-secondary-color) !important;
      }
    }
    .plot-container.plotly {
      height: 100%;
    }
    // .display-value {
    //   position: relative;
    //   width: 100%;
    //   top: -117px;
    //   text-align: center;
    //   cursor: pointer;
    // }
  }
</style>